module.exports = __webpack_public_path__ + "static/4-64889cba78daed84fe02eead6fb1f8a9.png";